import api from "../../../services/api";

export const getRevenueOverTime = async () => {
  const { data } = await api.get("/api/sales_reports/sales_over_time");
  return data;
};

export const getOrdersOverTime = async () => {
  const { data } = await api.get("/api/sales_reports/orders_over_time");
  return data;
};

export const getUnitsOverTime = async () => {
  const { data } = await api.get("/api/sales_reports/units_sold_over_time");
  return data;
};
